<script>
	export let width = '30px';
</script>

<svg
	fill="currentColor"
	version="1.1"
	id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	viewBox="0 0 512 512"
	xml:space="preserve"
	{width}
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<g>
			<g>
				<path
					d="M152.455,103.545L0,256l152.455,152.455H512V103.545H152.455z M472.229,368.684H168.928L56.244,256l112.684-112.684 h303.301V368.684z"
				/>
			</g>
		</g> <g> <g> <rect x="120.916" y="236.12" width="39.771" height="39.771" /> </g> </g>
		<g> <g> <rect x="233.6" y="196.349" width="159.083" height="39.771" /> </g> </g>
		<g> <g> <rect x="233.6" y="275.891" width="159.083" height="39.771" /> </g> </g>
	</g>
</svg>
